import type { AnswerForType } from "@tellescope/types-models";
import type { TellescopeFieldResponse } from "../types";

export const getLatestInsuranceAnswer = (
  responses: TellescopeFieldResponse[]
): AnswerForType["Insurance"] | undefined => {
  let result: AnswerForType["Insurance"] | undefined;
  for (const r of responses) {
    if (r.answer?.type === "Insurance" && r.answer.value?.payerId) {
      result = r.answer.value;
    }
  }
  return result;
};

export const getLatestAddressAnswer = (responses: TellescopeFieldResponse[]): AnswerForType["Address"] | undefined => {
  let result: AnswerForType["Address"] | undefined;
  for (const r of responses) {
    if (r.answer?.type === "Address") {
      result = r.answer.value;
    }
  }
  return result;
};

export const getLatestBridgeEligibilityAnswer = (
  responses: TellescopeFieldResponse[]
): AnswerForType["Bridge Eligibility"] | undefined => {
  let result: AnswerForType["Bridge Eligibility"] | undefined;
  for (const r of responses) {
    if (r.answer?.type === "Bridge Eligibility" && r.answer.value?.userIds?.length) {
      result = r.answer.value;
    }
  }
  return result;
};
